import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

import { FundingSection } from './FundingSection';
import type { AccountFundingProps } from './types';

import type { CollapseItemWithTypedSection } from '.';

export const getFundingSection = ({
  accountNumber,
  fundingInstructions,
  refetch
}: AccountFundingProps): CollapseItemWithTypedSection => {
  const isAnyFundingInformationChanged = fundingInstructions?.some(
    (item) => item?.changed
  );

  return {
    key: 'funding',
    label: (
      <div className="flex gap-2">
        {isAnyFundingInformationChanged ? (
          <ExclamationCircleIcon className="size-6 stroke-2 text-feedback-attention" />
        ) : null}
        <div>Funding instructions</div>
      </div>
    ),
    children: fundingInstructions && (
      <div className="px-2">
        <FundingSection
          fundingInstructions={fundingInstructions}
          refetch={refetch}
          accountNumber={accountNumber}
        />
      </div>
    )
  };
};
